import { Injectable } from '@angular/core';
import { Loading, LoadingController, ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import '../../node_modules/rxjs/add/operator/map';
import { Subscription } from 'rxjs'; //'../../node_modules/rxjs/subscription';
import { OrderHeaderModel } from '../models/order/orderheader.model';
import { OrderDetailModel } from '../models/order/orderdetail.model';
import { UtilService } from '../services/util.service';
import { StorageService } from '../services/storage.service';
import * as _ from "lodash";
import { AxiosHttpRequest } from '../infra/axioshttprequest';

@Injectable()
export class TransactionService {
    url: string;
    protocol: string;
    sub: Subscription;
    loading: Loading;

    constructor(
        private axiosHttpRequest: AxiosHttpRequest
        , private util: UtilService
        , private storageService: StorageService
        , private toastCtrl: ToastController
        , private loadingCtrl: LoadingController
    ) {
        if (location.protocol == 'file:') this.protocol = 'https:';
        else this.protocol = location.protocol;
    }

    retrieveTxnHistoryList(
        pageNum: number
        , salesrepCode: string
        , status: string
        , division: string 
        , startDate: string
        , endDate: string
        , baseSearch : string
        , searchField: string
        ,filterByOrderType:string
        , setting_id: string
    ) {
        const params = {
            pageIndex: pageNum.toString()
            , salesrepCode: salesrepCode
            , status: status
            , division: division
            , startDate: startDate
            , endDate: endDate
            , searchField: searchField
            , baseSearch: baseSearch
            ,filterByOrderType:filterByOrderType
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetTxnHistoryList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    // DMS STRY0015010 To allow DMS number to be searchable in order status ( adding dmsNo and invoiceNo to parameter)
    retrieveTxnOrderStatusList(
        pageNum: number
        , salesrepCode: string
        , status: string
        , custCode:string
        , startDate: string
        , endDate: string
        , searchTerm: string
        , setting_id: string
        , localRefNo: string
        , invoiceNo: string
        , poNo: string
    ) {
        const params = {
            pageIndex: pageNum.toString()
            , salesrepCode: salesrepCode
            , custCode: custCode
            , status: status
            , startDate: startDate
            , endDate: endDate
            , searchTerm: searchTerm
            , setting_id: setting_id
            // DMS STRY0015010 To allow DMS number to be searchable in order status
            , localRefNo: localRefNo
            , invoiceNo: invoiceNo
            // CCLIORDER-827 PO Enhancement
            , poNo: poNo
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetTxnOrderStatusList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveTxnOrderStatusDetail(txnNo: string, setting_id: string) {
        const params = {
            txnNo: txnNo
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetTxnOrderStatusDtl';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrievePayTermList(setting_id: string, salesrep_code: string, cust_code: string, division: string) {
        const params = {
            setting_id: setting_id
            , salesrep_code: this.storageService.getSettingId() === "1007" ? salesrep_code : ""
            , cust_code: this.storageService.getSettingId() === "1007" ? cust_code : ""
            , division: this.storageService.getSettingId() === "1007" ? division : ""
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetPayTermList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveFOCReasonList(setting_id: string) {
        const params = {
            setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetFOCReasonList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveCondGroupList(setting_id: string) {
        const params = {
            setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetCondGroupList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveCondGroup2List(setting_id: string) {
        const params = {
            setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetCondGroup2List';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveLineOrdDiscList(salesorg: string, division: string, team_code: string, setting_id: string) {
        const params = {
            salesorg_code: salesorg
            , div_code: division
            , team_code: team_code
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetLineOrdDiscList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveOrdDiscList(salesorg: string, division: string, setting_id: string) {
        const params = {
            salesorg_code: salesorg
            , div_code: division
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetOrdDiscList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveOrderList(order: OrderHeaderModel, setting_id: string) {
        const params = {
            setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetOrderList';
        return this.axiosHttpRequest.postWithHeaderParams(this.url, order, params);
    }

    retrieveOrderHistoryHeaderAndDetail(txnNo: string, salesrepCode: string, setting_id: string, type?: string, module_type?:string) {
        const params = {
            txnNo: txnNo
            , salesrep_code: salesrepCode
            , setting_id: setting_id
            , type: type
            , module_type: module_type
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetHistoryOrderHeaderAndDetail';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveTempOrder(salesrepCode: string, userId: string, setting_id: string) {
        const params = {
            salesrepCode: salesrepCode
            , userId: userId
            , setting_id: setting_id
        };
        
        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetTempSalesOrder';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveTempOrderDetail(txnNo: string, setting_id: string) {
        const params = {
            txnNo: txnNo
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetTempSalesOrderDetail';
        return this.axiosHttpRequest.get(this.url, params);
    }

    deleteTempOrder(salesrepCode: string, userId: string, setting_id: string) {
        const params = {
            salesrepCode: salesrepCode
            , userId: userId
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/DeleteTempSalesOrder';
        return this.axiosHttpRequest.get(this.url, params);
    }

    submitSalesOrder(salesrepCode: string, txnNo: string, txnStatus: string, setting_id: string) {
        const params = {
            salesrepCode: salesrepCode
            , txnNo: txnNo
            , txnStatus: txnStatus
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/SubmitSalesOrder';
        return this.axiosHttpRequest.get(this.url, params);
    }
    retriveUrgentOrderBlockDetail(txnNo: string, setting_id: string) {
        const params = {
              txnNo: txnNo
            , setting_id: setting_id
        };
        this.url = this.protocol + this.util.getWebServiceURL() +  'txn/GetUrgentOrderBlockDetail';
        return this.axiosHttpRequest.get(this.url, params);
    }
    retrieveOrderTxnNo(salesrepCode: string, userId: string, order: OrderHeaderModel, setting_id: string) {
        const params = {
            salesrepCode: salesrepCode
            , userId: userId
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetSalesOrderTxnNo';
        return this.axiosHttpRequest.postWithHeaderParams(this.url, order, params);
    }

    simplifyOrder(order: OrderHeaderModel) {
        let cOrder = _.cloneDeep(order),
            nOrderDetail: OrderDetailModel[] = []; //remove the reference 

        cOrder.detail.forEach((item) => {
            let o = new OrderDetailModel();
            o.prd_code = item.prd_code;
            o.foc_item = item.foc_item;
            o.quantity = item.quantity;
            o.default_quantity = item.default_quantity;
            o.uom_code = item.uom_code;
            o.line_type = item.line_type;
            o.gross_amt = item.gross_amt;
            o.cond_type = item.cond_type;
            o.ttl_disc_amt = item.ttl_disc_amt;
            o.ttl_net_amt = item.ttl_net_amt;
            o.ttl_tax_amt = item.ttl_tax_amt;
            o.high_level = item.high_level;
            o.sloc_code = item.sloc_code;
            o.plant = item.plant;
            o.batch_no = item.batch_no;
            o.batch_exp_date=item.batch_exp_date;
            o.shipping_point = item.shipping_point;
            o.itmtxt = item.itmtxt;
            o.tdid = item.tdid;
            o.lead_time= item.lead_time;
            o.shelf_life=item.shelf_life;
            o.registration_no= item.registration_no;
            nOrderDetail.push(o);
        });

        let undefinedSoItemList = nOrderDetail.filter((r) => { return r.line_type.sales_ind == 0 && r.high_level.so_item == undefined });
        if (!undefinedSoItemList) {
            undefinedSoItemList.forEach((value) => {
                let s = nOrderDetail.filter((r) => { return r.prd_code == value.prd_code && r.line_type.sales_ind == 1 })[0];
                if (s) {
                    value.so_item = s.so_item;
                }
            })
        }
        cOrder.detail = nOrderDetail;
        return cOrder;
    }

    updateTempTxnOrderDetail(order: OrderHeaderModel, setting_id: string, user_id:string) {
        const params = {
            setting_id: setting_id
            , user_id: user_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/UpdateTempOrder';
        return this.axiosHttpRequest.postWithHeaderParams(this.url, this.simplifyOrder(order), params);
    }

    createTempTxnOrderHeader(order: OrderHeaderModel, salesrepCode: string, userId: string, setting_id: string) {
        this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Generating order transaction number");
        let noPendingSub: Boolean = false;
        if (this.sub) {
            if (this.sub.closed)
                noPendingSub = true;
        } else
            noPendingSub = true;

        if (noPendingSub) {
            this.sub = this.retrieveOrderTxnNo(salesrepCode, userId, order, setting_id).subscribe(
                (data) => {
                    order.txn_no = data ? data : '';
                    // this.storage.set('order', order);
                    this.storageService.setOrder(order).then(() => {
                        this.loading.dismiss();
                        this.util.displayToast(this.toastCtrl, "Transaction number generated");
                    });
                });
        }
    }

    deleteKIVOrder(txnNo: string, salesrepCode: string, setting_id: string) {
        const params = {
            txnNo: txnNo
            , salesrepCode: salesrepCode
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/CancelKIVOrder';
        return this.axiosHttpRequest.get(this.url, params);
    }

    ftpSendEmail(principal_code: string, txnNo: string, soNo: string, setting_id: string){
        const params = {
            principal_code: principal_code
            , txnNo: txnNo
            , so_no: soNo
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/FTPAttachments';
        return this.axiosHttpRequest.get(this.url, params);
    }

    ftpSendEmailForCLientSAP(principal_code: string, txnNo:string, setting_id:string){
        const params = {
            principal_code: principal_code
            , txnNo: txnNo
            , setting_id: setting_id
        };
       
        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/FTPAttachmentsForClientSAP';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveOrderTrackingList(soNo:string, setting_id:string){
        const params = {
            so_no: soNo
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetOrderTracking';
        return this.axiosHttpRequest.get(this.url, params);
    }

    insertTxnOrderHistFromSAP(so_no: string, setting_id: string){
        const params = {
            so_no: so_no
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/InsertTxnOrderHistFromSAP';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveReturnOrderStatusList(pageNum: number, salesrepCode: string, searchTerm: string, setting_id: string) {
        const params = {
            pageIndex: pageNum.toString()
            , salesrepCode: salesrepCode
            , searchTerm: searchTerm
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetReturnOrderStatusList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    checkDuplicateSO(txn_no: string, po_no: string, setting_id:string){
        const params = {
            txn_no: txn_no
            , po_no: po_no
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/CheckDuplicateSO';
        return this.axiosHttpRequest.get(this.url, params);
    }

    checkSplitOrder(txn_no: string, setting_id:string){
        const params = {
            txn_no: txn_no
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/CheckSplitOrder';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveSummaryOrderList(ind: string, salesrepCode: string,setting_id: string) {
        const params = {
            ind: ind
            , salesrepCode: salesrepCode
            , setting_id: setting_id
        }

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetSummaryOrderList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    copyOrder(
        to_copy_txn_no: string
        , salesrepCode: string
        , custCode: string
        , salesOrg: string
        , shiptoCode:string
        , division: string
        , distchannel: string
        , payment_term: string
        , order_reason: string
        , payer_code: string
        , affiliate_order: string
        , userID: string
        , setting_id: string
    ) {
        const params = {
            to_copy_txn_no: to_copy_txn_no
            , salesrep_code: salesrepCode
            , cust_code: custCode
            , sales_org_code: salesOrg
            , shipto_code: shiptoCode
            , division: division
            , distchannel: distchannel
            , payment_term: payment_term
            , order_reason: order_reason
            , payer_code: payer_code
            , affiliate_order: affiliate_order
            , user_id: userID
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/CopyOrder';
        return this.axiosHttpRequest.get(this.url, params);
    }

    submitQuotation(salesrepCode: string, txnNo: string, txnStatus: string, setting_id: string) {
        const params = {
            salesrepCode: salesrepCode
            , txnNo: txnNo
            , txnStatus: txnStatus
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/SubmitQuotation';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveAuditLog(principalCode: string, txnNo:string, setting_id:string){
        const params = {
            strPrincipalCode: principalCode
            , txnNo: txnNo
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetAuditLogList';
        return this.axiosHttpRequest.get(this.url, params);
    }
    retrieveMarketingManagerList(principalCode: string, txnNo:string, setting_id:string){
        const params = {
            strPrincipalCode: principalCode
            , txnNo: txnNo
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetMarketingManagerList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveSLOCList(setting_id: string, salesorg: string, plant: string){
        const params = {
            setting_id: setting_id
            , salesorg: _.isEmpty(salesorg) ? '' : salesorg
            , plant: _.isEmpty(plant) ? '' : plant
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetSLOCList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    // TODO: NO ONE CALL THIS. BUT WHY DO WE HAVE TWO API WITH SAME NAME GetPlantList
    retrievePlantList(setting_id: string, salesorg: string) {
        const params = {
            setting_id: setting_id
            , salesorg: salesorg
        }
        
        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetPlantList';
        this.axiosHttpRequest.get(this.url, params);
    }

    // After check, HK and TW not having select sloc feature
    // MY SG TH THCG not filter by plant
    // VN will be filtered by plant
    // WARNING: FOC will cause this function error because there is no plant in FOC Order => considered plant if filter by plant
    retrieveBatchNoList(setting_id: string, plant: string, sloc:string, prd_code: string){
        const params = {
            setting_id: setting_id
            , sloc: sloc
            , plant: _.isEmpty(plant) ? '' : plant
            , prd_code: prd_code
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetBatchNoList';
        return this.axiosHttpRequest.get(this.url, params);
    }


    retrieveBatchNumberListFromSAP(
        setting_id: string
        , plant: string
        , sloc:string
        , prd_code: string
        , batch: string
        , sales_org: string
        , distChannel: string
        , uom: string
    ) {
        const params = {
            setting_id: setting_id
            , sloc: sloc
            , plant: plant
            , prd_code: prd_code
            , batch: batch
            , uom: uom
            , sales_org: sales_org
            , distChannel: distChannel
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetBatchNoListFromSAP';
        return this.axiosHttpRequest.get(this.url, params);
    }

    // After check, HK and TW not having select sloc feature
    // MY SG TH THCG not filter by plant
    // VN will be filtered by plant
    // WARNING: FOC will cause this function error because there is no plant in FOC Order => considered plant if filter by plant
    retrieveBatchExpDateList(setting_id: string, plant: string, sloc:string, prd_code: string, batch_no:string){
        const params = {
            setting_id: setting_id
            , sloc: sloc
            , plant: _.isEmpty(plant) ? '' : plant
            , prd_code: prd_code
            , batch_no: batch_no
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetBatchExpDateList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    //Giang - STRY0017242 - To add additional field shipping condition in EPC
    retrieveShippingConditionList(setting_id: string, order: OrderHeaderModel) {
        const params = {
            setting_id: setting_id
        }

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetShippingConditionList';
        return this.axiosHttpRequest.postWithHeaderParams(this.url, order, params);
    }

    retrieveDivisionList(setting_id: string) {
        const params = {
            setting_id: setting_id
        }

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetDivisionList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveProductChangedDetails(setting_id: string, txn_no: string, prd_code: string) {
        const params = {
            setting_id: setting_id
            , txn_no: txn_no
            , prd_code: prd_code
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetProductDescriptionDetails';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveChiangMaiShippingConditionValidation(setting_id: string, order: OrderHeaderModel) {
        const params = {
            setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/RetrieveChiangMaiShippingConditionValidation';
        return this.axiosHttpRequest.postWithHeaderParams(this.url, order, params);
    }

    getOrderSimulationResult(order: OrderHeaderModel, setting_id: string, sim_id: number) {
        const params = {
            setting_id: setting_id
            , sim_id: sim_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetOrderSimulationResult';
        return this.axiosHttpRequest.postWithHeaderParams(this.url, order, params);
    }

    retrieveOrderSimulationId(order: OrderHeaderModel, setting_id: string) {
        const params = {
            setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'txn/GetOrderSimulationId';
        return this.axiosHttpRequest.postWithHeaderParams(this.url, order, params);
    }
}



// WEBPACK FOOTER //
// ./src/services/transaction.service.ts